import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "upload-file"
};
var _hoisted_2 = {
  class: "file-info"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 0,
  class: "upload-btn"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 1
};
import { ref, watch, computed } from 'vue';
import { fileClass, imgCoverMap } from '@/utils/index';
import { MessagePlugin } from 'tdesign-vue-next';
import { uploadObs } from 'hxhy-obs';
import { getEnv } from '@/util/env';
import { getStore } from '@/util/store';
import { v4 } from 'uuid';

/* 变量 */

export default {
  __name: 'UploadFile',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxlength: {
      type: [String, Number],
      default: 5
    },
    maxSize: {
      type: [Object, Number],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    }
  },
  emits: ['update:list'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 工具 */
    var emit = __emit;
    var props = __props;
    var upload = ref();
    var fileList = ref([]);
    var FILE_TYPE_MAP = {
      '.ppt': 'powerpoint',
      '.pptx': 'presentation',
      '.pdf': 'pdf',
      '.doc': 'word',
      '.docx': 'word'
    };

    /* 计算属性 */
    var accepts = computed(function () {
      var _props$accept$split;
      return ((_props$accept$split = props.accept.split(',')) === null || _props$accept$split === void 0 ? void 0 : _props$accept$split.map(function (e) {
        return e.trim();
      })) || [];
    });
    var acceptsTypes = computed(function () {
      var _accepts$value;
      return (_accepts$value = accepts.value) === null || _accepts$value === void 0 ? void 0 : _accepts$value.map(function (e) {
        return FILE_TYPE_MAP[e] || e;
      });
    });

    /* 监听 */
    watch(function () {
      return props.list;
    }, function (list) {
      list && (fileList.value = list);
    }, {
      deep: true
    });

    /* 事件 */
    // 文件封面图
    var fileCover = function fileCover(item) {
      var fileType = fileClass(item.url);
      return imgCoverMap[fileType];
    };

    // 上传获取url
    var getUrl = function getUrl(file) {
      var fileType = fileClass(file.name);
      var fileTypeMap = {
        'file-doc': 1,
        'file-pic': 2,
        'file-video': 3,
        'file-audio': 4,
        'file-zip': 5
      };
      var userInfo = getStore({
        name: 'userInfo'
      });
      return new Promise(function (resolve) {
        var obsData = {
          bucketName: "hxhy-activity-".concat(getEnv()),
          file: file,
          fileType: fileTypeMap[fileType] || 6,
          userId: userInfo.id,
          userName: userInfo.name,
          institutionId: userInfo.institutionId,
          institutionName: userInfo.institutionName,
          appCode: 'activity',
          appName: '活动',
          pageName: 'researchTrain',
          btnName: '教研上传'
        };
        uploadObs(obsData).then(function (url) {
          resolve(url);
        });
      });
    };

    // 上传回调
    var handleUpload = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var _file$, _acceptsTypes$value;
        var fileData, type, index, url, name, fileType, response, newFiles;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              fileData = props.multiple ? (_file$ = file[0]) === null || _file$ === void 0 ? void 0 : _file$.raw : file === null || file === void 0 ? void 0 : file.raw;
              type = fileData.type;
              index = (_acceptsTypes$value = acceptsTypes.value) === null || _acceptsTypes$value === void 0 ? void 0 : _acceptsTypes$value.findIndex(function (e) {
                return type.includes(e);
              });
              if (!(acceptsTypes.value.length && index === -1)) {
                _context.n = 1;
                break;
              }
              MessagePlugin.warning("\u4E0D\u652F\u6301\u8BE5\u683C\u5F0F\u6587\u4EF6\u4E0A\u4F20\uFF01");
              return _context.a(2, new Promise(function (resolve) {
                resolve({
                  status: 'fail'
                });
              }));
            case 1:
              _context.n = 2;
              return getUrl(fileData);
            case 2:
              url = _context.v;
              name = fileData.name;
              fileType = fileClass(fileData.name);
              response = {
                id: v4() + +new Date(),
                file: fileData,
                url: url,
                fileType: fileType,
                name: name,
                suffix: url.slice(url.lastIndexOf('.') + 1)
              };
              newFiles = props.multiple ? [].concat(_toConsumableArray(props.list), [response]) : [response];
              emit('update:list', newFiles);
              return _context.a(2, new Promise(function (resolve) {
                resolve({
                  status: 'success',
                  response: response
                });
              }));
          }
        }, _callee);
      }));
      return function handleUpload(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 删除文件
    var deleteFile = function deleteFile(item) {
      var _item$response;
      var delId = (item === null || item === void 0 || (_item$response = item.response) === null || _item$response === void 0 ? void 0 : _item$response.id) || (item === null || item === void 0 ? void 0 : item.id);
      if (!delId) return;
      var fileList = props.list.filter(function (e) {
        return e.id !== delId;
      });
      emit('update:list', fileList);
    };

    // 文件校验
    var handleValidate = function handleValidate(e) {
      if (e.type === 'FILES_OVER_LENGTH_LIMIT') {
        MessagePlugin.warning("\u6700\u591A\u4E0A\u4F20".concat(props.maxlength, "\u4E2A\u6587\u4EF6\uFF01"));
      }
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_upload = _resolveComponent("t-upload");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_upload, {
        ref_key: "upload",
        ref: upload,
        modelValue: fileList.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return fileList.value = $event;
        }),
        accept: props.accept,
        requestMethod: handleUpload,
        multiple: props.multiple,
        max: props.multiple ? Number(props.maxlength) : 0,
        sizeLimit: props.maxSize,
        draggable: "",
        allowUploadDuplicateFile: "",
        theme: "custom",
        onValidate: handleValidate
      }, {
        dragContent: _withCtx(function (params) {
          return [_createElementVNode("div", {
            class: "file-list",
            onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "file-item"
            }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              src: fileCover(item),
              alt: "",
              class: "cover"
            }, null, 8, _hoisted_3), _createElementVNode("span", null, _toDisplayString(item.name), 1)]), _createVNode(_component_svg_icon, {
              class: "icon",
              name: "dialog-close-white",
              onClick: _withModifiers(function ($event) {
                return deleteFile(item);
              }, ["stop"])
            }, null, 8, ["onClick"])]);
          }), 128))]), fileList.value.length < Number(props.maxlength) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [params !== null && params !== void 0 && params.dragActive ? (_openBlock(), _createElementBlock("span", _hoisted_5, "松开鼠标")) : (_openBlock(), _createElementBlock("div", _hoisted_6, _toConsumableArray(_cache[2] || (_cache[2] = [_createElementVNode("span", {
            class: "blue"
          }, "点击上传", -1), _createElementVNode("span", null, "/", -1), _createElementVNode("span", null, "拖拽到此区域", -1)]))))])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue", "accept", "multiple", "max", "sizeLimit"])]);
    };
  }
};